import {
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from '@/components/ui/select';
import React, { useEffect, useState } from 'react';

export type InputSelectOptionType = {
  value: string;
  label: string | React.ReactNode;
};

type InputSelectType = {
  defaultValue?: string;
  options: InputSelectOptionType[];
  disabled?: boolean;
  placeholder?: string;
  onChange: (value?: string) => void;
};

export default function InputSelect({
  defaultValue,
  options,
  disabled,
  placeholder,
  onChange,
}: InputSelectType) {
  const [value, setValue] = useState(defaultValue);

  const onChangeValue = (value: string) => {
    onChange(value);
    setValue(value);
  };

  useEffect(() => {
    setValue(defaultValue);
  }, [defaultValue]);

  return (
    <Select disabled={disabled} onValueChange={onChangeValue} value={value}>
      <SelectTrigger className='w-full p-2 text-xs'>
        <SelectValue placeholder={placeholder} />
      </SelectTrigger>
      <SelectContent className='text-xs'>
        {options.map((option) => (
          <SelectItem key={option.value} value={option.value} className='text-xs'>
            {option.label}
          </SelectItem>
        ))}
      </SelectContent>
    </Select>
  );
}
